// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  Stack,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  instance: __t.u32(),
  x: __t.f32(),
  y: __t.f32(),
  owner: __t.u64(),
  ownerIdentity: __t.option(__t.identity()).name("owner_identity"),
  get contents() {
    return __t.array(Stack);
  },
  ageTicks: __t.u32().name("age_ticks"),
});
